<template>
  <div>
    <breadcrumbs
      v-if="participantUserId !==undefined"
      :crumbs="[{name:`${participantSingularName} Dashboard`, link: 'Dashboard Participant', id: participantUserId}, `${participantSingularName} Details`]"
    />
    <breadcrumbs
      v-else
      :crumbs="[`${participantSingularName} Details`]"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 reset-right">
            <div class="portlet light avatar-sidebar">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase" v-if="participantUserId === undefined">
                    New {{ participantSingularName.toLowerCase() }}
                  </span>
                  <span class="caption-subject bold uppercase" v-if="participantUserId !== undefined && user !== ''">
                    {{ name }}
                  </span>
                </div>
              </div>
              <div class="row">
                <avatar v-bind:username="name"
                        v-bind:src="($route.params.historyid == null) ? user.avatar : avatarHistory"
                        :size="140"
                        :rounded="true" color="#d09f23"
                        backgroundColor="#eef1f5"></avatar>
              </div>
              <div v-if="participantUserId != undefined">
                <a class="btn green" @click="toggleShow">Upload Image</a>
                <vue-image-crop-upload field="img"
                                       @crop-success="cropSuccess"
                                       v-model="show"
                                       :noRotate="false"
                                       :width="300"
                                       :height="300"
                                       lang-type="en"
                                       img-format="png"/>
                <button class="btn default" @click.prevent="updateAvatar(null)">Remove</button>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div class="portlet light">
              <div class="portlet-title tabbable-line">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase" v-if="$route.params.historyid == null">{{ participantSingularName }} details</span>
                  <span class="caption-subject bold uppercase" v-else="">Assignment History - {{ formDate | formatDateModalNoTimeZone }}</span>
                </div>
                <ul class="nav nav-tabs profile-tabs">
                  <li v-for="(form, index) in forms" @click="clearModifyForms()"
                      :class="{ active: query.activeTab === generateId(form.name) || !query.activeTab && index == 1, disabled: index != 1 && !participantUserId}" v-if="form.forms[0] != null">
                    <a :href="'#' + generateId(form.name)" data-toggle="tab" aria-expanded="false">{{ form.name }}</a>
                  </li>
                  <li :class="{ active: query.activeTab === 'correspondence', disabled: !participantUserId}" @click="clearModifyForms()" v-if="forms.length != 0 && logged.access > 2">
                    <a href="#correspondence" data-toggle="tab" aria-expanded="false">Correspondence</a>
                  </li>
                  <li :class="{ active: query.activeTab === 'modifyForms', disabled: !participantUserId}" v-if="$route.params.historyid != null && logged.access > 2">
                    <a href="#modifyForms" data-toggle="tab" aria-expanded="false">Modify Forms</a>
                  </li>
                  <li :class="{ active: query.activeTab === 'communication-notes', disabled: !participantUserId }" @click="clearModifyForms()" v-if="$route.params.historyid != null && logged.access > 2">
                    <a href="#communication-notes" data-toggle="tab" aria-expanded="false">Communication Notes</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content marginTop">
                <div v-for="(form, index) in forms" class="tab-pane"
                     :class="{ active: query.activeTab === generateId(form.name) || !query.activeTab && index == 1 }"
                     :id="generateId(form.name)"
                     v-if="(index == 1 || participantUserId) && form.forms[0] != null">
                  <spinner v-if="showLoading || showParticipantCloneLoading"/>

                  <vue-form-render v-if="!showParticipantCloneLoading && !initialReferralDataLoading"
                                   ref="formRender"
                                   :schema="form.forms[0].data"
                                   :conditions="form.forms[0].conditionals"
                                   :hideValues="form.forms[0].hide_values ? JSON.parse(form.forms[0].hide_values) : '[]'"
                                   :systemConditions="form.forms[0].system_conditionals"
                                   :validation-conditions="form.forms[0].extra_validation_rules"
                                   :calculations="form.forms[0].calculations"
                                   :values="form.forms[0].values"
                                   :name="generateId(form.name)"
                                   :programs="programs"
                                   v-show="isFormShown(form)"
                                   :lockform="isFormLocked(form)"
                                   :formblock="formBlock"
                                   :map="form.forms[0].columns_map"
                                   :latestDismissedAssignment="isLatestDismissedAssignment"
                                   :date-format="logged.date_format"
                                   :user-access-level="logged.access"
                  />
                  <div class="row" v-if="form.key === 'participants_assignment'">
                    <div class="col-md-12">
                      <button class="btn green"
                              v-show="!hasAssignment && !showForm && user.assignments && user.assignments.length !== 0"
                              v-if="logged.access > 2"
                              @click="showAssignmentForm" style="margin-bottom:20px;">Add New Assignment
                      </button>
                    </div>
                    <div class="col-md-12" v-if="user.assignments && user.assignments.length">
                      <div class="mt-element-list assignment-elements">
                        <div class="mt-list-head list-simple font-white bg-yellow">
                          <div class="list-head-title-container">
                            <div class="list-date"></div>
                            <h5 class="list-title">ASSIGNMENT HISTORY</h5>
                          </div>
                        </div>
                        <div class="mt-list-container list-simple">
                          <ul>
                            <li class="mt-list-item" v-for="record in user.assignments">
                              <div class="list-icon-container done">
                                <i class="fa fa-check"></i>
                              </div>
                              <div class="list-datetime">{{
                                record.programStatusStartDate.date |
                                formatDateModalNoTimeZone }} - {{
                                record.programStatusEndDate ?
                                record.programStatusEndDate.date : '' |
                                formatDateModalNoTimeZone }}
                              </div>
                              <div class="list-item-content"
                                   :class="(currentLoading == record.id) ? 'loading' : ''">
                                <h4 :class="(record.id == $route.params.historyid) ? 'active' : ''">
                                  <router-link
                                      :to="{ name: 'Participant History', params: { id: participantUserId, historyid: record.id } }"
                                      tag="a" active-class="active">{{
                                    record.programStatus }}
                                    {{ (record.id == $route.params.historyid) ?
                                    '(active)' : '' }}
                                    <i class="fa fa-spinner fa-pulse fa-fw hide"></i>
                                  </router-link>
                                </h4>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <br>
                    </div>
                  </div>
                  <button class="btn green mt-ladda-btn ladda-button formSave"
                          data-style="expand-left" :id="generateId(form.name)+'_context'"
                          @click.prevent="submitForm(form)"
                          v-if="!lockedForm
                                && !(form.key === 'participants_assignment' && logged.access < 3)
                                && !(!$route.params.historyid && user.status === 0 && (['profile','contact'].includes(form.role)))
                                && !($route.params.historyid && form.key === 'participants_assignment' && logged.access < 3)"
                  >
                    <span class="ladda-label">Save</span>
                  </button>
                  <router-link :to="{ name: 'Participant Edit', params: { id: $route.params.id } }"
                               tag="button"
                               type="button" class="btn default"
                               v-if="($route.params.historyid != null && !lockedForm) && !($route.params.historyid && form.key == 'participants_assignment' && logged.access < 4)">
                    Cancel
                  </router-link>
                  <button class="btn green"
                          v-if="lockedForm && !(form.key == 'participants_assignment' && logged.access < 3)"
                          @click="lockedForm = false">Modify
                  </button>

                  <router-link
                      :to="{ name: 'Dashboard Participant', params: { id: $route.params.id } }"
                      tag="button"
                      type="button" class="btn green" v-if="$route.params.id != null">
                    {{ participantSingularName }} Dashboard
                  </router-link>

                  <a @click="printPage('/print/form/' + form.forms[0].data_id)"
                     class="btn default pull-right"
                     v-if="['Participant Profile','Entity Profile'].includes(form.name)">Print</a>
                  <!--</form>-->
                </div>


                <div class="tab-pane" :class="{active: query.activeTab === 'correspondence'}" id="correspondence" style="padding-top:5px;" v-if="forms.length !== 0">
                  <correspondence :user="logged"/>
                </div>
                <div class="tab-pane" :class="{active: query.activeTab === 'modifyForms'}" id="modifyForms" style="padding-top:5px;" v-if="$route.params.historyid != null && logged.access > 2">
                  <vue-good-table
                      :columns="columnsModifyForms"
                      :rows="rowsModifyForms"
                      :globalSearch="false"
                      :paginate="false"
                  >
                    <template slot="table-row" slot-scope="props">
                      <a @click="showModifyForms(props.row.type)" v-bind:class="{'bold': isModified(props.row.type)}">{{ props.row.name }}</a>
                    </template>
                  </vue-good-table>
                  <br>
                  <router-link :to="{ name: 'Dashboard Participant', params: { id: $route.params.id } }" tag="button"
                               type="button" class="btn green" v-if="$route.params.id != null">
                    {{ participantSingularName }} Dashboard
                  </router-link>
                </div>

                <div class="tab-pane" :class="{active: query.activeTab === 'communication-notes'}" id="communication-notes" v-if="$route.params.historyid != null && logged.access > 2">
                  <communication-notes :participant-id="$route.params.id" :assignment-id="$route.params.historyid"></communication-notes>
                </div>
              </div>
            </div>

            <div v-if="modifyForms === 'assessment'" style="margin-top:10px">
              <forms-page type="assessment_outcomes" :sort-by-name="true" :history="true" :force-read-only="(logged.access < 4)"></forms-page>
            </div>
            <div v-if="modifyForms === 'activities'" style="margin-top:10px">
              <forms-page type="activities_services" :sort-by-name="true" :history="true" :force-read-only="(logged.access < 4)"></forms-page>
            </div>

          </div>
        </div>
      </div>
    </div>
    <confirm-assignment-overwrite-modal
      v-if="showAssignmentConfirmationModal"
      @confirm="confirmAssignmentOverwrite"
      @hidden="showAssignmentConfirmationModal = false"
    />
    <existing-participant-modal
      v-if="showExistingParticipantModal"
      :user="logged"
      :columns="existingParticipantColumns"
      :found-users="foundUsers"
      @confirm="submitForm(forms[1], true)"
      @hidden="showExistingParticipantModal = false"
    />
  </div>
</template>
<script>
  import {HTTP, ERROR} from '@/http-common';
  import _ from 'lodash';
  import Avatar from '@/components/menu/Avatar';
  import VueFormRender from '@/components/formbuilder/VueFormRender';
  import VueImageCropUpload from 'vue-image-crop-upload';
  import {mapActions, mapGetters} from 'vuex';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import ConfirmAssignmentOverwriteModal from '@/components/modals/ConfirmAssignmentOverwriteModal';
  import ExistingParticipantModal from '@/components/modals/ExistingParticipantModal';
  import Spinner from '@/components/Spinner';
  import FORM from '@/components/widgets/FormCRUD';
  import Vue from "vue";
  import CommunicationNotes from "./Participant/CommunicationNotes";
  import {RouteName} from "../enums/routeName";
  import {ModuleType} from "../enums/moduleType";
  import {QueryParam} from "../enums/queryParam";
  import ActionsMenu from "../components/reusables/ActionsMenu";
  import ActionsMenuItem from "../components/reusables/ActionsMenuItem";
  import Correspondence from "./Participant/Correspondence";
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        query: {
          activeTab: null,
          moduleId: null,
        },
        initialReferralDataLoading: true,
        forms: [],
        participantUserId: this.$route.params.id,
        currentLoading: '',
        hasAssignment: false,
        hasActiveAssignment: false,
        assignmentChangePasswordData: {},
        showAssignmentConfirmationModal: false,
        showExistingParticipantModal: false,
        showForm: false,
        lockedForm: false,
        formBlock: [],
        formDate: '',
        showLoading: false,
        avatarHistory: undefined,
        avatar: undefined,
        foundUsers: [],
        show: false,
        imgDataUrl: '',
        existingParticipantColumns: [],
        columnsModifyForms: [
          {
            label: 'Modify Forms',
            field: 'name'
          },
        ],
        rowsModifyForms: [
          {
            name: 'Activities and Services',
            type: 'activities'
          },
          {
            name: 'Assessment and Outcomes',
            type: 'assessment'
          },
        ],
        modifyForms: '',
        isLatestDismissedAssignment: false,
        showParticipantCloneLoading: false,
        programs: [],
        referralId: null,
      }
    },

    components: {
      VueFormRender,
      Correspondence,
      Avatar,
      CommunicationNotes,
      ActionsMenu,
      ActionsMenuItem,
      VueImageCropUpload,
      Breadcrumbs,
      Spinner,
      ConfirmAssignmentOverwriteModal,
      ExistingParticipantModal,
      'forms-page': FORM,
    },

    beforeMount() {
      this.getForm('core', this.participantUserId).then(() => {
        if (this.$route.params.referralId) {
          this.referralId = this.$route.params.referralId;
          this.getDataFromReferral();
        }else {
          this.initialReferralDataLoading = false
        }
      });
      this.loadParticipant(this.participantUserId);
    },
    mounted() {
      this.setDataFromQuery();
      this.showModifyFormModuleFromQueryParam()

      if (this.$route.params.id == null && this.logged.access < 3) {
        this.$notify({
          type: 'error',
          text: "Error. No access."
        });
        this.$router.push({name: 'Dashboard'});
      }
    },
    computed: {
      ...mapGetters({
        user: 'getParticipant',
        logged: 'getUser',
        organization: 'getOrganization'
      }),
      name: function () {
        let name = 'Case MGR';
        if (this.participantUserId && this.user.first_name && this.user.last_name) {
          name = this.user.first_name + " " + this.user.last_name;
        }
        if (this.participantUserId && this.user.name) {
          name = this.user.name;
        }
        return name
      }
    },

    methods: {
      ...mapActions([
        'setErrors', 'loadParticipant', 'GET_USER_DATA_REFRESH_ACTION'
      ]),
      showModifyFormModuleFromQueryParam(){
        if (!this.query.moduleId){
          return;
        }

        this.showModifyForms(this.getModuleTypeByModuleId(this.query.moduleId))
      },
      getModuleTypeByModuleId(moduleId) {
        if (!moduleId){
          return ''
        }

        if (parseInt(moduleId) === ModuleType.ACTIVITIES_SERVICES){
          return "activities"
        }
        if (parseInt(moduleId) === ModuleType.ASSESSMENT_OUTCOMES){
          return "assessment"
        }

        return ''
      },
      setDataFromQuery() {
        this.query.activeTab = this.$route.query[QueryParam.ACTIVE_TAB] || null;
        this.query.moduleId = this.$route.query[QueryParam.MODULE_ID] || null;
      },
      toggleShow() {
        this.show = !this.show;
      },
      cropSuccess(imgDataUrl) {
        this.imgDataUrl = imgDataUrl;
        this.updateAvatar(imgDataUrl);
      },
      showAssignmentForm() {
        this.showForm = true;
        $('#tab_assignment_form').show();
      },
      isFormShown(form) {
        return (!(form.key === 'participants_assignment' && form.forms[0].values.length === 0)
          || this.showForm
          || !(this.user.assignments && this.user.assignments.length !== 0)
          || this.$route.params.historyid != null)
      },
      isFormLocked(form) {
        return this.lockedForm
          || (form.key === 'participants_assignment' && this.logged.access < 3)
          || (!this.$route.params.historyid && this.user.status === 0 && ['profile','contact'].includes(form.role))
      },
      getForm(key, id) {
        return new Promise((resolve, reject) => {
          this.forms = [];
          let data = {group: key, assignment_id: null};
          if (id) {
            data.element_id = id;
          }

          if (this.$route.params.historyid == null) {
            this.showLoading = true;
            HTTP.post(`/modules/forms`, data)
              .then(response => {
                ERROR(response);

                if (response.data.status === 'success') {
                  this.showLoading = false;
                  this.forms = response.data.data.forms;
                  this.programs = response.data.data.programs;
                  this.hasAssignment = this.forms[3].forms[0].values.length !== 0;
                  this.hasActiveAssignment = response.data.data.has_active_assignment;
                  this.isLatestDismissedAssignment = response.data.data.is_latest_dismissed_assignment;
                  if (this.$route.name === RouteName.PARTICIPANT_ASSIGNMENT) {
                    _.delay(function () {
                      $("a[href='#tab_assignment']").trigger('click');
                    }, 300);
                  }
                  if (this.$route.name === RouteName.PARTICIPANT_CONTACT) {
                    _.delay(function () {
                      $("a[href='#tab_primaryContact']").trigger('click');
                    }, 300);
                  }
                  resolve(true);
                }
              })
              .catch(err => {
                console.log(err);
                reject(true);
              })
          } else {
            $('#tab_assignment_form').show();
            this.currentLoading = this.$route.params.historyid;
            data.assignment_id = this.$route.params.historyid;

            HTTP.post(`modules/forms`, data)
              .then(response => {
                ERROR(response);
                if (response.data.status === 'success') {
                  this.forms = response.data.data.forms;
                  this.formDate = response.data.data.history.assignment.programStatusEndDate.date;
                  this.formBlock.push(response.data.data.history.assignment.programStatus.name);
                  this.lockedForm = true;
                  this.hasAssignment = true;
                  this.hasActiveAssignment = response.data.data.has_active_assignment;
                  this.isLatestDismissedAssignment = response.data.data.is_latest_dismissed_assignment;
                  this.programs = response.data.data.programs;
                  if (response.data.data.history != null) {
                    this.user.avatar = response.data.data.history.assignment.avatar;
                    this.avatarHistory = response.data.data.history.assignment.avatar;
                  }
                  this.currentLoading = '';
                  resolve(true);
                }
              }).catch(err => {
              this.currentLoading = '';
              console.log(err);
              reject(true);
            })
          }
        })
      },

      generateId(name) {
        name = name === 'Status' ? 'Assignment' : name;
        return 'tab_' + _.camelCase(name);
      },

      submitForm(form, force=false) {
        // get child form component to trigger the validation
        const formId = this.generateId(form.name)
        const formComponent = this.$refs.formRender.find(c => c.name === formId);

        formComponent.submit().then(results => {
          if (results.isValid) {
            this.onBeforeSubmit(formId, results, form.key, form.forms[0].id, form.forms[0].data_id, force)
          }
        })
      },

      onBeforeSubmit(form, formData, module, id, dataId, force) {
        if (module === 'participants_assignment' && this.hasActiveAssignment) {
          HTTP.post('modules/confirm-current-assignment-overwrite', {
            formData: formData.fields,
            dataId: dataId
          }).then((response) => {
            if (response.data.data.must_confirm !== false) {
              this.assignmentChangePasswordData = {
                form,
                formData,
                module,
                id,
                dataId,
                force
              };
              this.showAssignmentConfirmationModal = true;
            } else {
              this.onSubmit(form, formData, module, id, dataId, force);
            }
          });
          return;
        }

        this.onSubmit(form, formData, module, id, dataId, force);
      },

      confirmAssignmentOverwrite() {
        const {form, formData, module, id, dataId, force} = this.assignmentChangePasswordData;
        this.onSubmit(form, formData, module, id, dataId, force);
      },

      onSubmit(form, formData, module, id, dataId, force) {
        if(this.$route.params.cloneFromId) {
          force = true;
        }

        let context = document.querySelector('#' + form + '_context');
        this.button = Ladda.create(context);
        this.button.start();

        this.formData = new FormData();

        let newId, newAssignment;

        let allData = {
          form_id: id,
          data_id: dataId,
          data: formData.fields,
          participant_user_id: this.participantUserId,
          referral_id: this.referralId,
          force_save: force
        };

        if (this.$route.params.historyid != null) {
          allData.assignment_id = this.$route.params.historyid;
        }

        this.formData.append('data', JSON.stringify(allData));

        let endpoint = dataId ? '/form/update-values' : '/form/create-values';

        formData.files.forEach((file, index) => {
          this.formData.append(file.field + '-' + index, file.file);
        })

        HTTP.post(endpoint, this.formData).then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.savedDataId = response.data.data.data_id;
            this.$notify(response.data.data.message);

            newId = response.data.data.id;
            newAssignment = response.data.data.assignment_status;

            if(!this.participantUserId) {
              this.$router.push({name: 'Participant Edit', params: {id: newId}});
              this.participantUserId = newId;
            } else {
              this.loadParticipant(this.participantUserId);
              this.getForm('core', this.participantUserId);

              if (newAssignment === 'dismissed') {
                $('#tab_assignment_form').trigger('reset').hide();
                this.hasAssignment = false;
              }
            }

            if (response.data.data.hasOwnProperty('update_messages')) {
              this.GET_USER_DATA_REFRESH_ACTION();
            }

            if (response.data.data.hasOwnProperty('assignment_removed') && this.$route.params.historyid === response.data.data.assignment_removed) {
              this.$router.push({name: 'Participant Edit', params: {id: this.participantUserId}})
            }
          } else {
            if (response.data.hasOwnProperty('data') && response.data.data.users != null && response.data.data.users.length) {
              this.existingParticipantColumns = response.data.data.columns;
              this.foundUsers = response.data.data.users;
              this.showExistingParticipantModal = true;
            } else {
              if(response.data.hasOwnProperty('data')) {
                this.setErrors(response.data.data);
                this.$notify({
                  type: 'error',
                  text: 'Correct form errors.'
                });
              } else {
                this.$notify({
                  type: 'error',
                  text: response.data.message
                });
              }
            }
          }
        }).catch(err => {
          this.showLoading = false;
          this.$notify({
            type: 'error',
            text: err.response.data.message
          });
          console.log(err);
        }).finally(() => {
          this.showLoading = false;
          this.button.stop();
        });
      },

      updateAvatar(file) {
        let request = {file, user_id: this.participantUserId};
        if (this.$route.params.historyid !== null) {
          request.assignment_id = this.$route.params.historyid;
        }
        HTTP.post('users/avatar', request)
          .then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.user.avatar = response.data.data.name;
              this.$notify('Profile image updated.');
              if (this.$route.params.historyid != null) {
                this.avatarHistory = response.data.data.name;
              }
            }
          }).catch(err => {
          console.log(err);
        })
      },

      showModifyForms(type) {
        this.modifyForms = type
      },

      isModified(type) {
        return this.modifyForms === type
      },

      clearModifyForms() {
        this.modifyForms = ''
      },

      printPage(url) {
        window.open(url, 'Print', 'left=0, top=0, width=1200, height=500, toolbar=0, resizable=0');
      },
      getDataForClone(cloneFromId) {
        this.showParticipantCloneLoading = true;
        HTTP.get('users/profile/get-for-clone/' + cloneFromId).then(response => {
          if (response.data.status === 'success') {
            this.forms[1].forms[0].values = response.data.data.values;
            this.showParticipantCloneLoading = false;
          } else {
            Vue.prototype.$notify({
              type: 'error',
              text: response.data.message
            });
            this.showParticipantCloneLoading = false;
          }
        });
      },
      getDataFromReferral() {
        this.showLoading = true;

        HTTP.get('referrals/get-for-new-participant/' + this.referralId).then(response => {
          if (response.data.status === 'success') {
            this.forms[1].forms[0].values = response.data.data.values;
            this.showLoading = false;
          } else {
            Vue.prototype.$notify({
              type: 'error',
              text: response.data.message
            });
            this.showLoading = false;
          }

          this.initialReferralDataLoading = false
        });
      },
    },

    watch: {
      '$route.params.id': function () {
        this.participantUserId = this.$route.params.id;
        this.avatar = undefined;
        this.avatarHistory = undefined;
        this.lockedForm = false;
        this.getForm('core', this.participantUserId);
        this.loadParticipant(this.participantUserId);
        $("a[href='#tab_participantsProfile']").trigger('click');
        this.modifyForms = '';
      },
      '$route.params.historyid': function () {
        this.loadParticipant(this.participantUserId);
        this.getForm('core', this.participantUserId);
        this.modifyForms = '';
      },
      '$route.params.cloneFromId': function (newVal) {
        if (newVal) {
          this.getDataForClone(this.$route.params.cloneFromId);
        }
      },
      '$route.params.referralId': function (newVal) {
        this.referralId = newVal;
        if (newVal) {
          this.getDataFromReferral();
        }
      },
      forms: function () {
        if (this.$route.params.cloneFromId && this.forms[1]) {
          this.getDataForClone(this.$route.params.cloneFromId);
        }
      },
    }

  }
</script>
<style>
  .marginTop {
    padding-top: 10px;
  }

  .reset-right {
    padding-right: 0px;
  }

  .avatar-sidebar .btn {
    margin-top: 15px;
  }

  .avatar-sidebar {
    text-align: center;
    padding: 12px 20px 25px 20px !important;
  }

  li.disabled {
    cursor: not-allowed;
  }

  li.disabled a {
    pointer-events: none;
    color: rgb(169, 168, 168) !important;
  }

  .assignment-elements li h4 {
    margin: 0px;
    font-size: 16px;
  }

  .assignment-elements li h4.active {
    font-weight: 600;
  }

  .assignment-history li a {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// Participant.vue?429627c6